import ArticleAttachmentSummaryIndicator from '@buildwise/pages/knowledge/components/ArticleAttachmentSummaryIndicator';
import { ArticleType, AttachmentType } from '@buildwise/pages/knowledge/hooks/useArticlesQuery';
import { IconButton, Typography } from '@mui/material';
import { theme } from 'config/theme';
import useUserData from 'hooks/useUserData';
import { memo } from 'react';
import Attachment2Icon from 'remixicon-react/Attachment2Icon';

type PostAttachmentsCountWithBannerProps = {
  article: ArticleType;
  documents: AttachmentType[];
  showAttachmentSummaryIndicatorSkeleton?: boolean;
};

function PostAttachmentsCountWithBanner({
  article,
  documents,
  showAttachmentSummaryIndicatorSkeleton,
}: PostAttachmentsCountWithBannerProps) {
  const { company } = useUserData();
  const commentAttachmentsSummaryCount =
    article?.commentAttachmentIds?.reduce((acc, group) => {
      return acc + group.reduce((innerAcc, item) => innerAcc + item.attachmentIds.length, 0);
    }, 0) || 0;

  return (
    <>
      <IconButton
        size="small"
        className="no-hover"
        sx={(theme) => ({ color: theme.palette.custom.mediumBlack })}
      >
        <Attachment2Icon size={20} color={theme.palette.custom.link} />
        &nbsp;
        <Typography sx={(theme) => ({ color: theme.palette.custom.link })}>
          {documents.length + commentAttachmentsSummaryCount}
          {documents.length + commentAttachmentsSummaryCount > 1 ? ' Attachments' : ' Attachment'}
        </Typography>
      </IconButton>
      {!!company?.settings?.articlesLLMSearch &&
        (!!article?.attachments?.find(
          (attachment) => attachment?.pageNo && attachment.pageNo?.length > 0,
        ) ||
          (!!article?.commentAttachmentIds?.length && commentAttachmentsSummaryCount > 0)) && (
          <ArticleAttachmentSummaryIndicator
            showAttachmentSummaryIndicatorSkeleton={showAttachmentSummaryIndicatorSkeleton}
          />
        )}
    </>
  );
}

export default memo(PostAttachmentsCountWithBanner);
